import {LangKeyType} from '../../../../../provider/locale/translation/type';
import {FakeSearchInCitiesEnum} from '../../../../../service/fakes/fakes-type';

export const citiesModeKey: Record<FakeSearchInCitiesEnum, LangKeyType> = {
    [FakeSearchInCitiesEnum.All]: 'FAKES__SETTINGS__CITIES__ALL',
    [FakeSearchInCitiesEnum.BigCities]: 'FAKES__SETTINGS__CITIES__BIG',
    [FakeSearchInCitiesEnum.ClientCities]: 'FAKES__SETTINGS__CITIES__CLIENT_LOCATION',
};
